import { PropsWithChildren } from 'react';
import { IconSize } from './types';

export function getSize(size: IconSize | number): number {
  if (typeof size === 'number') {
    return size;
  }
  if (size === IconSize.SMALL) {
    return 16;
  }
  if (size === IconSize.LARGE) {
    return 32;
  }
  if (size === IconSize.X_LARGE) {
    return 40;
  }
  return 24;
}

export function SvgIcon(
  props: PropsWithChildren<{ size: IconSize | number; viewBox?: string }>,
) {
  const { size, children, viewBox } = props;
  return (
    <svg
      style={{ display: 'block', transform: 'rotate(0deg)' }}
      width={getSize(size)}
      height={getSize(size)}
      viewBox={viewBox || '0 0 12 12'}
      xmlns="http://www.w3.org/2000/svg"
      className="tw-store-component-icon"
    >
      {children}
    </svg>
  );
}
